import { useQuery } from "@tanstack/react-query";
import { getGraphQLClient } from "../lib/graphql";

interface SalesPeopleGroupByResponse {
  factInvoices: {
    groupBy: { fields: { SalesPerson: string | null } }[];
  };
}

const SALES_PEOPLE_QUERY = `
  query {
    factInvoices {
      groupBy(fields: [SalesPerson]) {
        fields {
          SalesPerson
        }
      }
    }
  }
`;

export function useSalesPeople(isAuthenticated: boolean) {
  const {
    data: salesPeople = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["salesPeople"],
    queryFn: async ({ signal }) => {
      const response =
        await getGraphQLClient().request<SalesPeopleGroupByResponse>(
          SALES_PEOPLE_QUERY,
          signal,
        );
      const groups = response.factInvoices?.groupBy || [];
      return groups
        .map((g) => g.fields.SalesPerson)
        .filter((s): s is string => typeof s === "string" && s !== "")
        .sort((a, b) => a.localeCompare(b));
    },
    enabled: isAuthenticated,
    staleTime: Infinity,
    retry: 2,
  });

  return { salesPeople, isLoading, error };
}
